import { Action } from '@ngrx/store';

export enum ChartsActionTypes {
    ChartsRevenueReset = '[Charts][Revenue] Reset',
    ChartsRevenueAna2Select = '[Charts][Revenue][Ana2] Select element',
    ChartsRevenueAna3Select = '[Charts][Revenue][Ana3] Select element',
    ChartsRevenueByCategorySelect = '[Charts][Revenue][Category] Select element',
    ChartsExpensesReset = '[Charts][Expenses] Reset',
    ChartsExpensesAna2Select = '[Charts][Expenses][Ana2] Select element',
    ChartsExpensesAna3Select = '[Charts][Expenses][Ana3] Select element',
    ChartsExpensesByCategorySelect = '[Charts][Expenses][Category] Select element',
}

export class ChartsExpensesReset implements Action {
    readonly type = ChartsActionTypes.ChartsExpensesReset;
    constructor() { }
}
export class ChartsExpensesAna2Select implements Action {
    readonly type = ChartsActionTypes.ChartsExpensesAna2Select;
    constructor(public payload: { timeline: string, ana2Name: string }) { }
}
export class ChartsExpensesAna3Select implements Action {
    readonly type = ChartsActionTypes.ChartsExpensesAna3Select;
    constructor(public payload: { ana3Name: string }) { }
}
export class ChartsExpensesByCategorySelect implements Action {
    readonly type = ChartsActionTypes.ChartsExpensesByCategorySelect;
    constructor(public payload: { timeline: string, providerCategory: string }) { }
}

export class ChartsRevenueReset implements Action {
    readonly type = ChartsActionTypes.ChartsRevenueReset;
    constructor() { }
}
export class ChartsRevenueAna2Select implements Action {
    readonly type = ChartsActionTypes.ChartsRevenueAna2Select;
    constructor(public payload: { timeline: string, ana2Name: string }) { }
}
export class ChartsRevenueAna3Select implements Action {
    readonly type = ChartsActionTypes.ChartsRevenueAna3Select;
    constructor(public payload: { ana3Name: string }) { }
}
export class ChartsRevenueByCategorySelect implements Action {
    readonly type = ChartsActionTypes.ChartsRevenueByCategorySelect;
    constructor(public payload: { timeline: string, customerCategory: string }) { }
}

export type ChartsActions =
    ChartsExpensesAna2Select
    | ChartsExpensesAna3Select
    | ChartsExpensesByCategorySelect
    | ChartsRevenueAna2Select
    | ChartsRevenueAna3Select
    | ChartsRevenueByCategorySelect;
